<div class="checkbox">
  <p-checkbox
    #checkbox
    [attr.id]="checkboxId"
    [binary]="binary"
    [disabled]="disabled"
    [readonly]="readonly"
    [inputId]="inputId"
    (onChange)="handleChange($event)"
    [(ngModel)]="checked"
    styleClass="mr-2">
  </p-checkbox>
</div>
